import {JSX, Show, splitProps} from "solid-js";
import ZagPasswordInput, {ZagPasswordInputProps} from "~/components/zag/ZagPasswordInput";
import {FaSolidEye, FaSolidEyeSlash} from "solid-icons/fa";
import css from "./password-input.module.css"

export interface PasswordInputProps extends Omit<ZagPasswordInputProps, 'children'> {
    input: (props: any) => JSX.Element;
}

export default function PasswordInput(props: PasswordInputProps) {

    const [_, zagProps] = splitProps(props, [])

    return (
        <ZagPasswordInput {...zagProps}>
            {(api) => (
                <div {...api.getRootProps()}>
                    <div {...api.getControlProps()} class={css.control}>
                        <props.input {...api.getInputProps()}/>
                        <button {...api.getVisibilityTriggerProps()} class={css.toggle}>
                            <span {...api.getIndicatorProps()} class={css.indicator}>
                                <Show when={api.visible} fallback={<FaSolidEyeSlash class={css.icon}/>}>
                                    <FaSolidEye class={css.icon}/>
                                </Show>
                            </span>
                        </button>
                    </div>
                </div>
            )}
        </ZagPasswordInput>
    )
}